import clsx from 'clsx'
import {FC, useMemo} from 'react'
// import {initialQueryState} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'

type Props = {
  className?: string
  title: string
  tableProps: any
}

const BlockUserCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])

  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    if (id === 'actions' || id === 'selection') return

    if (!isSelectedForSorting) {
      updateState({sort: id, order: 'asc'})
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        updateState({sort: id, order: 'desc'})
        return
      }

      updateState({sort: undefined, order: undefined})
    }
  }

  const headerProps = tableProps.column.getHeaderProps()
  const {key, ...restProps} = headerProps as any

  return (
    <th
      key={key}
      {...restProps}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`,
        id === 'actions' && 'text-center'
      )}
      onClick={sortColumn}
    >
      <span className='text-gray-800'>{title}</span>
    </th>
  )
}

export {BlockUserCustomHeader}
